import { lazy, Suspense } from "react";
import { usePlainT, useWordingTools } from "../../i18n/I18nProvider";
import { Icon } from "../../ui/Icon";
import { useCan } from "../club";
import "./wording.css";

const TextEditHost = lazy(() => import("./TextEditHost"));

/** Top-bar switch for "Edit text on screen", shown to people who may change the club's wording (`clubs.text`). */
export function EditTextToggle() {
  const t = usePlainT();
  const can = useCan();
  const { editing, setEditing } = useWordingTools();
  if (!can("clubs.text")) return null;
  return (
    <button
      type="button"
      className="cc-icon-button wording-toggle"
      aria-pressed={editing}
      aria-label={t("wording.toggle")}
      title={t("wording.toggle")}
      data-cc-text-editor=""
      onClick={() => setEditing(!editing)}
    >
      <Icon name="edit" />
    </button>
  );
}

/** The editing layer (banner and editor). Its code loads only when the mode is first turned on. */
export function EditTextLayer() {
  const can = useCan();
  const { editing } = useWordingTools();
  if (!editing || !can("clubs.text")) return null;
  return (
    <Suspense fallback={null}>
      <TextEditHost />
    </Suspense>
  );
}
